import { css } from "../../../styled-system/css";

export const styles = {
  contactCard: () =>
    css({
      width: "100%",
      backgroundColor: "backgroundGrey",
      display: "flex",
      flexWrap: "wrap",
    }),
  featuredImage: () =>
    css({
      flex: "1 1 436px",
      maxWidth: "100%",
      tablet: {
        flex: "0 0 436px",
        maxWidth: "100%",
      },
    }),
  featuredImageWrapper: () =>
    css({
      position: "relative",
      height: "100%",
      paddingTop: "63%", // proportion of image
      overflow: "hidden",
      cursor: "pointer",
      display: "block",
      width: "100%",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "top center",
        position: "absolute",
        left: "0",
        top: "0",
      },
    }),
  backgroundWrapper: () =>
    css({
      flex: "1 1 300px",
      backgroundColor: "backgroundGrey",
      paddingTop: "baseUnit.mobile2",
      paddingBottom: "baseUnit.mobile3",
      paddingX: "baseUnit.mobile2",
      desktop: {
        paddingX: "baseUnit.mobile3",
        paddingTop: "baseUnit.mobile3",
        paddingBottom: "baseUnit.mobile4",
      },
    }),
  contentWrapper: () =>
    css({
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    }),
  contactWrapper: () =>
    css({
      marginBottom: "baseUnit.mobile1",
      "& span": {
        fontSize: "body.horse",
        display: "block",
        lineHeight: "body.horse",
        "&:first-of-type": {
          fontWeight: "bold",
        },
      },
    }),
  emailWrapper: () =>
    css({
      display: "flex",
      marginTop: "baseUnit.mobile2",
      marginBottom: "baseUnit.mobile3",
      desktop: {
        marginTop: "baseUnit.mobile3",
        marginBottom: "baseUnit.mobile4",
      },
      "& div": {
        marginRight: "3px",
      },
      "& a": {
        fontSize: "body.horse",
        lineHeight: "body.horse",
      },
    }),
  followUsWrapper: () =>
    css({
      flex: "0 0 290px",
      "& span": {
        fontSize: "body.horse",
        fontWeight: "bold",
        display: "inline-block",
      },
    }),
};
